var map = {
	"../ajustes/ajustes.module": [
		"./src/app/ajustes/ajustes.module.ts",
		"ajustes-ajustes-module"
	],
	"../partes/partes.module": [
		"./src/app/partes/partes.module.ts",
		"partes-partes-module"
	],
	"./home/home.module": [
		"./src/app/home/home.module.ts",
		"home-home-module"
	],
	"./parte-detalle/parte-detalle.module": [
		"./src/app/parte-detalle/parte-detalle.module.ts",
		"parte-detalle-parte-detalle-module"
	],
	"./tabs/tabs.module": [
		"./src/app/tabs/tabs.module.ts",
		"tabs-tabs-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;